import React from 'react';
import PropTypes from 'prop-types';

import NoAsapSnackbar from 'base/components/NoAsapSnackbar';
import NoSetAddressSnackbar from 'base/components/NoSetAddressSnackbar';

import {
  NO_ASAP_FOR_DELIVERY_AND_PICKUP,
  NO_SET_ADDRESS,
  ASAP_NOT_AVAILABLE_FOR_THROTTLES
} from 'base/constants/orderAlerts';

import NoAsapForThrottlesSnackbar from 'base/components/NoAsapForThrottlesSnackbar';

const alertsComponent = {
  [NO_ASAP_FOR_DELIVERY_AND_PICKUP]: NoAsapSnackbar,
  [NO_SET_ADDRESS]: NoSetAddressSnackbar,
  [ASAP_NOT_AVAILABLE_FOR_THROTTLES]: NoAsapForThrottlesSnackbar
};

class OrderAlertManager extends React.Component {
  render() {
    const { alert } = this.props;

    const AlertComponent = alertsComponent[alert];

    return <AlertComponent open={true} {...this.props} />;
  }
}

OrderAlertManager.propTypes = {
  pickupTime: PropTypes.string,
  deliveryTime: PropTypes.string,
  deliveryPickup: PropTypes.string,
  alert: PropTypes.string
};

export default OrderAlertManager;
